export const featureList = [
  'Unlimited access to all games',
  'Learn 4,000+ curriculum-aligned skills',
  'Personalized Daily Learning Path',
  'Makes learning fun through',
  'Meaningful screen time',
  'Add up to 3 children',
  'Insightful and actionable reports',
  'Multiple device compatibility'
]